import styled from 'styled-components'
import theme, {colors} from '../../../styles/theme'

export const SidenavBox = styled.div<{height?: number; $isExpanded: boolean}>`
  background-color: #fff;
  box-sizing: border-box;
  max-width: 100%;
  border: 1px solid #ebeffc;
  border-radius: 2px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  max-height: 70vh;
  height: ${({$isExpanded, height}) =>
    $isExpanded
      ? `calc(${height}px + 5px); overflow: auto;`
      : '48px; overflow: hidden;'};
  width: ${({$isExpanded}) => ($isExpanded ? '100%' : '48px')};
  transition:
    width 0.3s ease,
    height 0.3s ease;

  position: sticky;
  top: 120px;

  &::-webkit-scrollbar {
    background: #ffffff;
    width: 8px;
    border: 0;
  }

  &::-webkit-scrollbar-thumb {
    width: 8px;
    border-radius: 100px;
    background: #d8d8d8;
    -webkit-box-shadow: none;

    &:hover {
      background: #d8d8d8;
    }
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
  }

  ${theme.breakpoints.down('md')} {
    margin: 8px 0;
    border-left: 0;
    position: fixed;
    z-index: 10;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  }
`

export const SidenavToggleBox = styled.div<{$isExpanded: boolean}>`
  padding: ${({$isExpanded}) => ($isExpanded ? `16px 24px 0` : '12px 8px')};
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: ${colors.bksGray80};
  width: fit-content;

  ${theme.breakpoints.down('md')} {
    padding: 12px 8px;
  }
`

export const SidenavExpandedContent = styled.div`
  display: flex;
  flex-flow: column;
`

export const HeaderTitle = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${colors.bksGray80};
  padding: 16px 24px;
`

export const Divider = styled.div`
  height: 1px;
  background-color: #ebeffc;
  width: 100%;
`

export const ObjectiveTitle = styled.p`
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: 700;
  color: ${colors.bksGray80};
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 16px 24px 0;
`

export const ObjectiveText = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.bksGray80};
  padding: 8px 24px 0;
`

export const DayItems = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: 16px;
`

export const DayItem = styled.div<{$isActive?: boolean; $isComplete?: boolean}>`
  ${({$isActive, $isComplete}) =>
    $isActive
      ? `
      background: ${colors.blue3};
      color: ${colors.blue1};
      border-left: 4px solid ${colors.blue1};
      padding: 16px 24px 16px 20px;
    `
      : $isComplete
      ? `
      color: ${colors.bksGray50};
      padding: 16px 24px;
    `
      : `
      color: ${colors.bksGray80};
      padding: 16px 24px;
    `}

  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    background: ${colors.blue3};
    color: ${colors.blue1};
    border-left: 4px solid ${colors.blue1};
    padding: 16px 24px 16px 20px;
  }
`

export const NextDay = styled.div`
  color: ${colors.bksGray80};
  padding: 16px 24px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-top: 1px solid #838383;

  &:hover {
    background: ${colors.blue3};
    color: ${colors.blue1};
    border-left: 4px solid ${colors.blue1};
    padding: 16px 24px 16px 20px;
  }
`

export const DayItemText = styled.p<{$isLarge?: boolean}>`
  margin: 0;
  padding: 0;
  ${({$isLarge}) => ($isLarge ? `font-size: 16px;` : `font-size: 14px;`)}
`

export const StyledIcon = styled.img`
  height: 32px;
`
